import { createStore } from "vuex";
import tabs from "./modules/tabs";
import lockscreen from "./modules/lockscreen";

export default createStore({
  state: {
    token: sessionStorage.getItem("token"),
    loginType:sessionStorage.getItem("login_type"),
    userName:sessionStorage.getItem("userName"),
    packInfo:{
      ywly_list_pack:true,
      fwjg_list_pack:true,
    },
    searchInfo:{
      currentPage:"",
      pageSize:"",
      keywords:"",
      keywords_old:"",
      datetime_range:[],
      zqgs_value:[],
      ywly_check_list:[],
      fwjg_check_list:[],
      key_tags:[],
      re_result_zqgs_check:[],
      re_result_ywly_check:[],
      re_result_fwjg_check:[],
      publishedTimeStr_sort:"",
      date_range_str_old: "",
      zqgs_value_old: [],
      ywly_check_list_old: [],
      fwjg_check_list_old: [],
    },
    // userInfo:{
    //   userName:"",
    //   sysID:"",
    // },
  },
  getters:{
    getLoginType(state) {
      return state.loginType;
    },
    getUserName(state) {
      return state.userName;
    },
    getSearchInfo(state) {
      return state.searchInfo;
    },
    getPackInfo(state) {
      return state.packInfo;
    },
    getToken(state) {
       return state.token;
    },
    
    
    // getUserInfo(state) {
    //   return state.userInfo;
    // },
  },
  mutations: {
    // getToken(state, token) {
    //   state.token = token;
    //   //sessionStorage.setItem("token", token);
    // },
    // getLoginType(state) {
    //   // 获取登陆类型
    //   state.loginType;
    // },
    setToken(state,token){
      // 设置标签页数据
      state.token = token;
      sessionStorage.setItem("token", token);
    },
    setLoginType(state,data){
      // 设置登陆类型
      // 参数：UIAS 统一登陆 XOC 默认用户体系 
      state.loginType = data;
      sessionStorage.setItem("login_type", data);
    },
    setUserName(state,data){
      // 设置用户基本数据
      state.userName = data;
      sessionStorage.setItem("userName", data);
    },
    setSearchInfo(state,data){
      // 设置用户基本数据
      state.searchInfo = data;
      sessionStorage.setItem("searchInfo", data);
    },
    setPackInfo(state,data){
      // 设置用户基本数据
      state.packInfo = data;
      sessionStorage.setItem("packInfo", data);
    },
    
    
    // setUserInfo(state,data){
    //   // 设置用户基本数据
    //   state.userInfo = data
    // },
  },
  actions: {},
  modules: {
    tabs,lockscreen,
  },
});
